import { runInAction } from 'mobx'

export default function inAction<T>(cb: () => T) {

    return () => runInAction(cb)
}
